import { render } from "./NewUserPage.vue?vue&type=template&id=bcd194b8&scoped=true&ts=true"
import script from "./NewUserPage.vue?vue&type=script&lang=ts"
export * from "./NewUserPage.vue?vue&type=script&lang=ts"

import "./NewUserPage.vue?vue&type=style&index=0&id=bcd194b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcd194b8"]])

export default __exports__